export const dnldRCSCampaignSummary = (builder) => ({
    dnldRCSCampaignSummary: builder.mutation({
        query: ({ loggedin_user_id, user_type_id, search, startDate, endDate }) => {
            return {
                url: process.env.REACT_APP_RCS_API_PORT + '/download_rcs_campaign_summary',
                method: 'GET',
                params: { loggedin_user_id, user_type_id, search, startDate, endDate },
                headers: {
                    'Content-Type': 'text/csv',
                  },
                  responseHandler: (response)=>response.blob(),
            };
        },
    }),
});